/**
 * The "Appears In" block: wraps the pre-built carousel HTML in the theme's
 * item-relations markup and hands the list to the same slider the native
 * carousel uses (Utils.initBxSlider + the site's bxSliderDefaults), so the
 * arrows, slide width and responsive behaviour match.
 *
 * Built on Backbone.View (public, has .extend). On this site's core (SCS 26.1)
 * 'SCView' exports an ES class wrapper ({ SCView }) with no .extend, so
 * SCView.extend threw at load and the module never defined (v1.0.0, 2026-10-09).
 */
define('Clemtex.AppearsIn.View', [
    'clemtex_appears_in.tpl',
    'Backbone',
    'Utils'
], function (template, Backbone, Utils) {
    'use strict';

    var CAROUSEL_FIELD = 'custitem_appears_in_carousel';

    var View = Backbone.View.extend({

        template: template,

        initialize: function initialize(options) {
            this.carouselHtml = View.cleanCarouselHtml(options && options.carouselHtml);
        },

        getContext: function getContext() {
            return {
                hasCarousel: !!this.carouselHtml,
                carouselHtml: this.carouselHtml
            };
        },

        render: function render() {
            var result = Backbone.View.prototype.render.apply(this, arguments);
            this.startSlider();
            return result || this;
        },

        startSlider: function startSlider() {
            if (!this.carouselHtml) { return; }
            var $list = this.$('[data-type="carousel-items"]');
            if (!$list.length || $list.closest('.bx-wrapper').length) { return; }
            try {
                // Same call as ItemRelations.Correlated.View. SC.CONFIGURATION is the
                // site's live configuration object (the Configuration module itself is
                // private under Safe Mode). initBxSlider is a no-op in the page generator.
                var config = window.SC && window.SC.CONFIGURATION;
                var defaults = (config && config.bxSliderDefaults) || View.FALLBACK_SLIDER;
                Utils.initBxSlider($list, defaults);
            } catch (e) {
                if (window.console) { window.console.warn('ClemtexAppearsIn slider skipped', e); }
            }
        }
    }, {
        // --- pure helpers (unit-tested in test/run-tests.js)

        // The PDP component hands back a deep copy of the view model:
        // { item: { ...item API fields... }, quantity, options }. Older cores
        // exposed the fields one level up, so both shapes are accepted.
        carouselHtmlFrom: function carouselHtmlFrom(itemInfo) {
            if (!itemInfo) { return ''; }
            var item = itemInfo.item || itemInfo;
            var value = item && item[CAROUSEL_FIELD];
            return typeof value === 'string' ? value : '';
        },

        // Accept only the markup the suitelet writes (a single carousel <ul>);
        // anything else (blank, whitespace, a stray value) renders nothing.
        cleanCarouselHtml: function cleanCarouselHtml(html) {
            if (typeof html !== 'string') { return ''; }
            var trimmed = html.replace(/^\s+|\s+$/g, '');
            if (!/^<ul\b[^>]*data-type="carousel-items"[^>]*>[\s\S]*<\/ul>$/.test(trimmed)) { return ''; }
            if (trimmed.indexOf('<li') === -1) { return ''; }
            return trimmed;
        },

        FALLBACK_SLIDER: {
            minSlides: 2,
            slideWidth: 228,
            maxSlides: 5,
            forceStart: true,
            pager: false,
            touchEnabled: true,
            nextText: '<a class="item-relations-related-carousel-next"><span class="control-text">next</span> <i class="carousel-next-arrow"></i></a>',
            prevText: '<a class="item-relations-related-carousel-prev"><i class="carousel-prev-arrow"></i> <span class="control-text">prev</span></a>'
        }
    });

    return View;
});
